import React from 'react';
import PropTypes from 'prop-types';

import useAuth from '../../../../../hooks/use-auth';
import Action from '../../Action/Action';

import * as styles from './UserPresentation.module.scss';
import { Routes } from '../../../../../helpers/routes';

const UserPresentation = ({
  name,
  surname,
  discount,
  nextDiscount,
  ordersToNextDiscount
}) => {
  const { user, logout } = useAuth();

  const promoCode = user.promo_codes ? user.promo_codes[0] : null;

  const handleLogout = () => {
    logout((callback) => {
      window.location = Routes.root;
    });
  };

  const handleReferalOrders = () => {
    window.location = Routes.referalOrders;
  };

  return (
    <div className={styles.UserPresentation}>
      <div className={styles.UserPresentation__nameContainer}>
        <div className={styles.UserPresentation__beforeName} />
        <div className={styles.UserPresentation__name}>
          <div>{user.name || name}</div>
          <div>{user.surname || surname}</div>
        </div>
        <div className={styles.UserPresentation__afterName}>
          {/* <div className={styles.UserPresentation__discount}>
            {`${discount}%`}
          </div> */}
        </div>
      </div>

      <Action
        onClick={handleLogout}
        themes={['Link']}
        className={styles.UserPresentation__logout}
      >
        Выход
      </Action>

      {promoCode && (
        <div className={styles.UserPresentation__nextDiscountMessage}>
          <span>
            Ваш промокод&nbsp;
            <strong>{promoCode.code?.toUpperCase()}</strong>
            , cумма вознаграждения за каждый заказ&nbsp;
            <strong>
              {promoCode.reward}
              &nbsp;₽
            </strong>
          </span>
          <span>
            <Action
              onClick={handleReferalOrders}
              themes={['Link']}
              className={styles.UserPresentation__ordersLink}
            >
              Смотрите список заказов
            </Action>
          </span>
        </div>
      )}
    </div>
  );
};

UserPresentation.propTypes = {
  name: PropTypes.string,
  surname: PropTypes.string,
  discount: PropTypes.number,
  nextDiscount: PropTypes.number,
  ordersToNextDiscount: PropTypes.number
};

UserPresentation.defaultProps = {
  name: '',
  surname: '',
  discount: 0,
  nextDiscount: 0,
  ordersToNextDiscount: 0
};

export default UserPresentation;
